import ConfigurePaymentDialog from './ConfigurePaymentDialog'

export default ConfigurePaymentDialog
